import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import isEqual from 'lodash/isEqual';
import { Modal } from 'antd';
import QuickCard from '../QuickCard';

import './QuickDataModal.css';

@inject('translationsStore', 'commonStore', 'pagedCollectionStore')
@observer
export default class QuickDataModal extends Component {
  constructor(props) {
    super(props);

    this.skeletonData = { keyName: '', color: '', caption: '', columns: [], collections: [] };

    this.state = {
      tabs: {}
    };
  }

  componentDidMount = () => {
    const tabs = this.availableModalTabs();
    this.setState({ tabs });
  };

  componentDidUpdate = prevProps => {
    const tabs = this.availableModalTabs();
    if (!isEqual(tabs, this.state.tabs)) {
      this.setState({ tabs });
    }
  };

  availableModalTabs = () => {
    const { pagedCollectionStore, namespacePrefix } = this.props;
    // const stage1 = pagedCollectionStore.getAny(namespacePrefix);
    // const stage2 = Object.keys(stage1)
    //   .filter(key => stage1[key].availableInTabs)
    //   .reduce((res, key) => Object.assign(res, { [key]: stage1[key] }), {});

    const { translationsStore } = this.props;
    const { keyName } = this.props.data ? this.props.data : this.skeletonData;
    let { tabs } = this.state;

    const currentIsPresent = !!tabs['current'];
    const count = pagedCollectionStore.get(`${namespacePrefix}.current`) ? pagedCollectionStore.get(`${namespacePrefix}.current`).count : 0;
    const labelCurrent =
      count === 1 ? translationsStore.translate(`quickhealth.${keyName}.captionOne`) : `${count} ${translationsStore.translate(`quickhealth.${keyName}.caption`)}`;

    tabs = {
      current: {
        label: labelCurrent,
        active: currentIsPresent ? tabs.current.active : true
      },
      historical: {
        ...tabs.historical,
        label: translationsStore.translate(`quickhealth.${keyName}.captionAll`),
        active: currentIsPresent ? tabs.historical.active : false
      }
    };

    return tabs;
  };

  showModalTab = index => {
    let { tabs } = this.state;

    Object.keys(tabs).forEach((key, tabIndex) => {
      tabs[key] = index === tabIndex ? { ...tabs[key], active: true } : { ...tabs[key], active: false };
    });

    this.setState({ tabs });
  };

  render() {
    const { color } = this.props.data ? this.props.data : this.skeletonData;
    const { tabs } = this.state;

    const {
      modal: { visible, onOk, onCancel }
    } = this.props;

    const activeKey = Object.keys(tabs)
      .filter(key => !!tabs[key].active)
      .shift();

    const title = (
      <Fragment>
        {Object.keys(tabs).map((key, index) => {
          let style = { cursor: 'pointer' };
          // if (tabs[key].active === true) {
          if (key === activeKey) {
            style = { ...style, borderBottomColor: color, color };
          }
          return (
            <div key={index} style={style} onClick={() => this.showModalTab(index)}>
              {tabs[key].label}
            </div>
          );
        })}
      </Fragment>
    );

    const { namespacePrefix } = this.props;

    return (
      <Modal className="QuickDataModal" width={820} title={title} visible={visible} footer={null} onOk={onOk} onCancel={onCancel}>
        {Object.keys(tabs).map(key => {
          if (tabs[key].active) {
            return (
              <div key={key}>
                <QuickCard data={{ ...this.props.data, collection: key }} collection={key} namespacedCollection={`${namespacePrefix}.${key}`} />
              </div>
            );
          }
          return undefined;
        })}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickDataModal/QuickDataModal.js